module.exports = __webpack_public_path__ + "img/recommend.9ace548.png";